<tm-error-alert
  (afterConfirm)="afterConfirm.emit()"
  (afterCancel)="afterCancel.emit()">
</tm-error-alert>
